<template>
    <div>
        <!-- WEB-->
        <v-app-bar
            app
            clipped-left
            light
            color="white"
            class="roma-app-bar"
            :class="`app-bar-${$route.name}`"
            elevation="3"
            style="box-shadow: 0 3px 6px rgba(0,0,0,.06)!important; z-index: 999 !important;"
        >
            <!-- desktop -->
            <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->

            <!-- brand-logo -->
            <div
                class="header-wrapper 
                d-flex 
                justify-space-between 
                align-center"
            >
                <div class="hidden-md-and-up">
                    <router-link
                        to=""
                        class="brand-logo mr-2"
                        style="cursor: default !important;"
                    >
                        <img
                            :src="logoRoma"
                            :lazy-src="logoRoma"
                            class=""
                            alt=""
                        />
                    </router-link>
                </div>

                <div
                    class="
                    left-side
                    justify-space-between 
                    align-center
                    hidden-sm-and-down"
                >
                    <router-link
                        to=""
                        class="brand-logo ml-12 offset-6"
                        style="cursor: default !important;"
                    >
                        <img
                            :src="logoRoma"
                            :lazy-src="logoRoma"
                            class=""
                            alt=""
                        />
                    </router-link>

                    <!-- title -->
                    <v-toolbar-title class="roma-toolbar-title ml-16">
                        Evaluaciones
                    </v-toolbar-title>
                </div>

                <!-- information block -->
                <!-- v-if="$route.name !== 'ErrorPage'" -->
                <div
                    class="
                    d-flex
                    align-center
                    justify-space-between 
                    information-wrapper
                    "
                    v-if="$route.name !== 'ErrorPage'"
                >
                    <!-- information -->
                    <div
                        class="user align-center d-flex mr-5"
                        v-if="user.institutionContext"
                    >
                        <div
                            class="user__icon mr-5
                            d-none d-sm-flex"
                        >
                            <v-img
                                :src="
                                    `https://plataforma.romacl.com/LogoInstitucion?id=${user.institutionContext.identificationCode}`
                                "
                                :lazy-src="
                                    `https://plataforma.romacl.com/LogoInstitucion?id=${user.institutionContext.identificationCode}`
                                "
                                width="30px"
                            ></v-img>
                        </div>
                        <div
                            class="user__information
                            text-caption
                            text-sm-body-1"
                        >
                            <p clasS="user__name text-uppercase ">
                                {{
                                    user.institutionContext.identificationCode
                                }}-{{ user.institutionContext.name }}
                            </p>
                            <p
                                class="user__period cardTitle--text text-uppercase"
                            >
                                AÑO ESCOLAR
                                {{ user.institutionContext.yearSelected }}
                            </p>
                        </div>
                    </div>
                    <!-- User -->
                    <div
                        class="d-flex 
                        justify-end
                        roma-app-bar__avatar-wrapper"
                        @click="handleLogout()"
                        title="Cerrar Sesión"
                    >
                        <div
                            class="text-right
                            text-caption
                            text-sm-body-1"
                        >
                            <p class="roma-app-bar__name text-capitalize">
                                {{ romaFullName }}
                            </p>
                            <p class="roma-app-bar__grade">
                                {{ section }}
                            </p>
                        </div>
                        <v-avatar
                            color="white"
                            class=" d-sm-block roma-app-bar__avatar ml-4"
                        >
                            <img
                                src="@/assets/images/avatar_default.png"
                                alt="John"
                            />
                        </v-avatar>
                    </div>
                    <div
                        class="logout"
                        v-if="showLogout"
                        @click="logout()"
                        v-click-outside="closeLogout"
                    >
                        <span>Cerrar sesión</span>
                    </div>
                </div>
            </div>
        </v-app-bar>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    props: {
        dpDrawer: {
            type: Function
        },
        dpTemporary: {
            type: Function
        }
    },
    data() {
        return {
            window: {
                width: 0,
                height: 0,
                colorBgMobile: false
            },
            showLogout: false,
            urlBaseLogo: `${process.env.VUE_APP_ROMA_WEB_ASSETS}/img/logo-roma.svg`
        };
    },
    created() {
        this.bgBarMobile();
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    computed: {
        ...mapGetters({
            user: "getUserData",
            getEnablePdfPollMobile: "getEnablePdfPollMobile"
        }),
        romaFullName() {
            if (
                typeof this.user.fullName !== "undefined" &&
                this.user.fullName !== null
            ) {
                return typeof this.user.fullName !== "undefined"
                    ? this.capitalizeFirstLetter(this.user.fullName)
                    : "";
            } else if (this.user.userName !== null) {
                return this.user.userName !== null
                    ? this.user.userName
                    : "USUARIO";
            } else {
                return this.user.fullName;
            }
        },
        section() {
            return this.user.abreviaturaSeccion;
        },
        logoRoma() {
            if (this.user.institutionContext) {
                return typeof this.user.institutionContext.implementerCode !==
                    "undefined"
                    ? `${process.env.VUE_APP_ROMA_WEB}/LogoInstitucion?id=${this.user.institutionContext.implementerCode}`
                    : `${process.env.VUE_APP_ROMA_WEB_ASSETS}/img/logo-roma.svg`;
            } else {
                return `${process.env.VUE_APP_ROMA_WEB_ASSETS}/img/logo-roma.svg`;
            }
        }
    },
    methods: {
        ...mapActions({
            toggleDrawer: "toggleDrawer",
            resetEvaluation: "resetEvaluation",
            resetUser: "resetUser",
            resetPdf: "resetPdf",
            resetTimer: "resetTimer",
            setTimeEndRemainingZero: "setTimeEndRemainingZero"
        }),
        handleLogout() {
            this.showLogout = !this.showLogout;
        },
        logout() {
            this.resetUser();
            this.resetEvaluation();
            this.resetPdf();
            this.resetTimer();
            this.setTimeEndRemainingZero(false);
            window.location = process.env.VUE_APP_ROMA_LOGOUT_CAS;
        },
        closeLogout() {
            this.showLogout = false;
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        bgBarMobile() {
            this.colorBgMobile = this.getEnablePdfPollMobile;
        }
    },
    updated() {
        this.bgBarMobile();
    }
};
</script>

<style lang="scss">
.mdi-menu {
    color: transparent !important;
}

.header-wrapper {
    width: 100%;
}
.roma-app-bar {
    z-index: 100;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.06) !important;
    .left-side {
        display: flex;
    }
    .brand-logo {
        img {
            width: 95px;
            height: 40px;
        }
    }
    .logout {
        position: absolute;
        padding: 10px 15px;
        background: #ffffff;
        top: 70px;
        right: 10px;
        width: 150px;
        border-radius: 7px !important;
        box-shadow: 0 2px 19px #00000042 !important;
        transition: box-shadow 0.5s ease;
        height: max-content;
        text-align: center;
        cursor: pointer;
        z-index: 150;
    }

    &__avatar-wrapper {
        margin-left: 70px;
        cursor: pointer;
    }

    @media (max-width: 959px) {
        .information-wrapper {
            width: 100%;
        }
        &__avatar-wrapper {
            margin-left: 0px;
            cursor: pointer;
        }
        .user__information {
            line-height: normal !important;
        }
    }
    @media (max-width: 599px) {
        &__avatar-wrapper {
            width: 100%;
        }
        &__avatar {
            height: 27px !important;
            min-width: 27px !important;
            width: 27px !important;
            display: block !important;
            // margin-left: auto;
        }
        .text-right {
            line-height: normal !important;
        }
        .user__information {
            line-height: normal !important;
        }
        .brand-logo {
            img {
                width: 48px;
                height: 20px;
            }
        }
    }
}
</style>
